import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import LeadSideBar from "../components/sidebar";
import LeadNav from "../components/leads/leadNav";
import NotificationToast from "../components/NotificationToast";
import { getVapidKey, saveSubscription } from "../../api/utils";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, "+")
    .replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

const LeadPanel = () => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const subscribePush = async () => {
      if (!("serviceWorker" in navigator && "PushManager" in window)) return;

      try {
        const swReg = await navigator.serviceWorker.register(
          "/serviceWorker.js"
        );
        const data = await getVapidKey();

        const subscription = await swReg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(data.publicKey),
        });

        // console.log("Browser subscription:", subscription);
        await saveSubscription(subscription);
      } catch (err) {
        console.error("Push subscription failed:", err);
      }
    };

    subscribePush();
  }, []);

  const removeNotification = (index) => {
    setNotifications((prev) => prev.filter((_, i) => i !== index));
  };

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        setNotifications((prev) => [
          ...prev,
          { ...event.data, timestamp: new Date().toLocaleTimeString() },
        ]);
      });
    }
  }, []);

  return (
    <div style={{ display: "flex" }}>
      <div className="row">
        <div className="col-2">
          <LeadSideBar />
        </div>
        <div className="col-10">
          <NotificationToast
            notifications={notifications}
            removeNotification={removeNotification}
          />
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default LeadPanel;
